import * as React from "react";
import { NumberInput, SelectInput, TextInput } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { PeriodMonths } from "../../../Constants/Constant";
import * as YearList from "../../../Constants/YearList";
import { useState } from "react";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { AircraftUtilizationStatus } from "../../../../src/Enums/AircraftUtilizationStatus";
import { useAuth } from "@airborne/react-admin";

const AircraftUtilizationCreateForm = () => {
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();
  const [acRegList, setAcRegList] = useState([] as any);

  React.useEffect(() => {
    GetAircraftList();
  }, []);

  const GetAircraftList = async () => {
    if (!user?.ownerCode) return;
    dataProvider
      .getList("cdmaircraft/GetAllCdmFleetData", {
        filter: {
          contractStatus__in: ["Active", "Hold"],
          contractOwnerName__eq: user?.ownerCode,
          isActive__eq: 1,
        },
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "id", order: "DESC" },
      })
      .then(response => {
        let data: any = response?.data;
        setAcRegList([]);
        if (data.length > 0) {
          setAcRegList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Info
                </Typography>
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <TextInput
                      source="ownerCode"
                      label="Owner Code"
                      variant="outlined"
                      defaultValue={user?.ownerCode}
                      fullWidth
                      disabled
                    ></TextInput>

                    <SelectInput
                      source="acRegId"
                      choices={acRegList}
                      optionText="acReg"
                      optionValue="id"
                      fullWidth
                      variant="outlined"
                      required
                    />
                  </Box>
                </Box>
              </Box>

              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <SelectInput
                    source="periodYear"
                    choices={YearList.default}
                    optionText="key"
                    optionValue="key"
                    fullWidth
                  ></SelectInput>

                  <SelectInput
                    source="periodMonth"
                    choices={PeriodMonths}
                    optionText="month"
                    optionValue="value"
                    fullWidth
                  ></SelectInput>
                </Box>
              </Box>

              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightCycle" label="FLIGHT CYCLE" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightHour" label="FLIGHT HOUR" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput source="flightMinute" label="FLIGHT MINUTE" fullWidth />
                </Box>

                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <NumberInput
                    source="status"
                    label="Status"
                    fullWidth
                    disabled
                    defaultValue={AircraftUtilizationStatus.Offered}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default AircraftUtilizationCreateForm;
